<mat-form-field
  [subscriptSizing]="input.subscriptSizing"
  [appearance]="input.appearance"
>
  @if (input.label | parse: context | async; as label) {
    <mat-label>{{ label }}</mat-label>
  }
  <textarea
    matInput
    [class]="input.textareaStyleClasses | parse: context | async"
    [formControl]="_formControl"
    [placeholder]="input.placeholder | parse: context | async"
    [required]="input.required"
    (blur)="onBlur($event)"
    [rows]="input.rows ?? 10"
    [class.no-resize]="input.resizable === false || input.resizable === 'auto'"
    [class.auto-resize]="input.resizable === 'auto'"
    (keydown.control.enter)="onCtrlEnter()"
  ></textarea>
  @if (input.suffix; as suffixWidget) {
    <ng-container matSuffix>
      <ng-container [dynamicWidget]="suffixWidget" [context]="context" />
    </ng-container>
  }
  @if (firstFormControlError; as error) {
    <mat-error>
      {{ error.errorMessage | parse: context | async }}
    </mat-error>
  }
</mat-form-field>
